import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import GuidesPage from './pages/Guides';
import ContactPage from './pages/Contact';
import CreerCompteParisEnLigne from './pages/guides/creer-compte-paris-en-ligne';
import DeposerArgentSiteParis from './pages/guides/deposer-argent-site-paris';
import RetirerGainsParis from './pages/guides/retirer-gains-paris';
import ComprendreCotesParis from './pages/guides/comprendre-cotes-paris';
import ChoisirMeilleurSiteParis from './pages/guides/choisir-meilleur-site-paris';
import StrategiesParisFootball from './pages/guides/strategies-paris-football';
import GestionBankrollParis from './pages/guides/gestion-bankroll-paris';
import CashOutParisDirect from './pages/guides/cash-out-paris-direct';
import BonusPromotionsExpliques from './pages/guides/bonus-promotions-expliques';
import NewsPage from './pages/News';
import NouveauxBonusDecembre2025 from './pages/news/nouveaux-bonus-decembre-2025';
import StrategiesParisFootballNews from './pages/news/strategies-paris-football';
import ComparatifCotesDecembre from './pages/news/comparatif-cotes-decembre';
import EvolutionMarcheParisLigneFrance2025 from './pages/news/evolution-marche-paris-ligne-france-2025';
import NouveauxOperateursAgreesAnj from './pages/news/nouveaux-operateurs-agrees-anj';
import ParisTennisTendancesOpportunites from './pages/news/paris-tennis-tendances-opportunites';
import SecuriteProtectionDonneesSitesParis from './pages/news/securite-protection-donnees-sites-paris';
import ParisCombinesMaximiserGains from './pages/news/paris-combines-maximiser-gains';
import ApplicationMobileVsSiteWeb from './pages/news/application-mobile-vs-site-web';
import ReviewsPage from './pages/Reviews';
import NetbetReview from './pages/reviews/netbet';
import UnibetReview from './pages/reviews/unibet';
import VbetReview from './pages/reviews/vbet';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AgeVerification />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/creer-compte-paris-en-ligne" element={<CreerCompteParisEnLigne />} />
        <Route path="/guides/deposer-argent-site-paris" element={<DeposerArgentSiteParis />} />
        <Route path="/guides/retirer-gains-paris" element={<RetirerGainsParis />} />
        <Route path="/guides/comprendre-cotes-paris" element={<ComprendreCotesParis />} />
        <Route path="/guides/choisir-meilleur-site-paris" element={<ChoisirMeilleurSiteParis />} />
        <Route path="/guides/strategies-paris-football" element={<StrategiesParisFootball />} />
        <Route path="/guides/gestion-bankroll-paris" element={<GestionBankrollParis />} />
        <Route path="/guides/cash-out-paris-direct" element={<CashOutParisDirect />} />
        <Route path="/guides/bonus-promotions-expliques" element={<BonusPromotionsExpliques />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/nouveaux-bonus-decembre-2025" element={<NouveauxBonusDecembre2025 />} />
        <Route path="/news/strategies-paris-football" element={<StrategiesParisFootballNews />} />
        <Route path="/news/comparatif-cotes-decembre" element={<ComparatifCotesDecembre />} />
        <Route path="/news/evolution-marche-paris-ligne-france-2025" element={<EvolutionMarcheParisLigneFrance2025 />} />
        <Route path="/news/nouveaux-operateurs-agrees-anj" element={<NouveauxOperateursAgreesAnj />} />
        <Route path="/news/paris-tennis-tendances-opportunites" element={<ParisTennisTendancesOpportunites />} />
        <Route path="/news/securite-protection-donnees-sites-paris" element={<SecuriteProtectionDonneesSitesParis />} />
        <Route path="/news/paris-combines-maximiser-gains" element={<ParisCombinesMaximiserGains />} />
        <Route path="/news/application-mobile-vs-site-web" element={<ApplicationMobileVsSiteWeb />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/reviews/netbet" element={<NetbetReview />} />
        <Route path="/reviews/unibet" element={<UnibetReview />} />
        <Route path="/reviews/vbet" element={<VbetReview />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;
